import { useTranslation } from 'react-i18next';
import Login from '../components/Login/Login';
import TempPassword from '../components/TempPassword';
import { useDataContext } from '../contexts/DataContext';
import Layout from './Layout';

const PageHome = () => {
    const { currentUserId, currentUserTemporaryPassword } = useDataContext();
    const { t } = useTranslation();

    if (currentUserTemporaryPassword)
        return (
            <Layout>
                <TempPassword />
            </Layout>
        );

    if (!currentUserId)
        return (
            <Layout>
                <Login />
            </Layout>
        );

    return (
        <Layout>
            <h1>{t('nav.home')}</h1>
            <h2>{t('feedback.welcome')}</h2>
            <p>{t('feedback.select_option')}</p>
        </Layout>
    );
};

export default PageHome;
